import type {EntityProfileMetaChip, EntityProfileSummaryField} from "~/components/entityProfile/types";
import type {OttopilotCustomer} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/ottopilotCustomersWorkspaceCapability/domain/OttopilotCustomer";
import {formatDateTime} from "~/utilities/utilities";

const SOURCE_FIELD_LABEL_HINTS = ["source", "channel", "platform"];

export function resolveCustomerProfileMetaChips(args: {
    customer: OttopilotCustomer;
    summaryFields: Array<EntityProfileSummaryField>;
}): Array<EntityProfileMetaChip> {
    const chips: Array<EntityProfileMetaChip> = [];

    const createdAtLabel = formatDateTime(String(args.customer.createdAt));
    if (createdAtLabel !== "" && createdAtLabel !== "-") {
        chips.push({id: "createdAt", kind: "calendar", label: createdAtLabel});
    }

    const sourceField = args.summaryFields.find((field) => {
        const label = field.label.toLowerCase();
        return (
            SOURCE_FIELD_LABEL_HINTS.some((hint) => label.includes(hint)) &&
            field.value !== "" &&
            field.value !== "-"
        );
    });
    if (sourceField !== undefined) {
        chips.push({id: sourceField.id, kind: "tag", label: sourceField.value});
    }

    return chips;
}
